module.exports = __webpack_public_path__ + "static/media/ic-dashboard.650e49e6.svg";